import { useCallback } from 'react';
import { gql, useMutation } from '@apollo/client';
import { useHandleApiErrors } from '../useHandleApiErrors';
import { toDeliverApplicationInput } from './toDeliverApplicationInput';

export const DELIVER_APPLICATION_GQL = gql`
  mutation deliverApplication($input: SaveApplicationInput!) {
    deliverApplication(input: $input) {
      status
    }
  }
`;

export function useDeliverApplication({ storeState, onSuccess, onError }) {
  const { applicationId } = storeState;

  const { handleError } = useHandleApiErrors('apollo', onError);
  const [deliverApplication, { loading }] = useMutation(DELIVER_APPLICATION_GQL, {
    ...(onSuccess
      ? {
          onCompleted: data => {
            onSuccess(data.deliverApplication);
          },
        }
      : {}),
    onError: err => {
      handleError(err);
    },
  });

  const deliver = useCallback(
    formData => {
      if (formData) {
        const input = { applicationId, ...toDeliverApplicationInput(formData, storeState) };
        deliverApplication({ variables: { input } });
      }
    },
    [applicationId, storeState, deliverApplication],
  );

  return {
    deliver,
    loading,
  };
}
